// import { DataService } from '../services/data_service';
import { ApiService } from '../services/api_service';
import { IDs } from '../helpers/IDs';
import { lazyInject } from '../services/inversify';
import * as React from 'react';
import { StructureTool } from '../core/forms/helpers/structure_tool';
import { WForm, WFormConfig, WFormData } from '../core/forms/WFormFramework';

interface EditExternerBeraterProps extends React.ClassAttributes<any> {
    data: any;
    onChange: (berater: any, isPreset: boolean) => void;
}

interface EditExternerBeraterState extends React.ClassAttributes<any> {
    formConfig: WFormConfig;
    formData: WFormData;
}

export class EditExternerBerater extends React.Component<EditExternerBeraterProps, EditExternerBeraterState> {
    constructor(props: any) {
        super(props);
        this.state = {
            formConfig: null,
            formData: null
        };
        this.onFormChange = this.onFormChange.bind(this);
        // this.validateField = this.validateField.bind(this);
    }

    // @lazyInject(DataService) private dataService: DataService;
    @lazyInject(ApiService) private apiService: ApiService;

    // private mails: any = {};

    componentDidMount() {
        this.getFormConfig();
        this.getFormData();
        // this.getMails();
    }

    // getMails() {
    //     this.dataService.loadData(
    //         IDs.ENT_USER, {}, { fieldList: 'tid, Mail' },
    //         (data: any) => {
    //             (this.props.data[IDs.ENT_BERATER] || []).forEach((item: any) => {
    //                 this.mails[item.tid] = (item.mail || '').toLowerCase();
    //             });
    //             this.dataService.loadData(
    //                 IDs.ENT_REGISTRIERUNG, {}, { fieldList: 'tid, mail' },
    //                 (data2: any) => {
    //                     ((data2 || {})[IDs.ENT_REGISTRIERUNG] || []).forEach((item2: any) => {
    //                         this.mails[`r${item2.tid}`] = (item2.mail || '').toLowerCase();
    //                     });
    //                 },
    //                 IDs.MOD_ETOOL_ADMIN
    //             );
    //             ((data || {})[IDs.ENT_USER] || []).forEach((item: any) => {
    //                 this.mails[`u${item.tid}`] = (item.Mail || '').toLowerCase();
    //             });
    //         },
    //         IDs.MOD_LEGACY
    //     );
    // }

    getFormConfig() {
        const struct_tool = new StructureTool(IDs.MOD_ETOOL_ADMIN);
        struct_tool.generateFormConfig(IDs.ENT_BERATER, (formConfig: WFormConfig) => {
            this.setState({ formConfig });
        });
    }

    getFormData() {
        const { data } = this.props;
        const formData = new WFormData();
        if (Array.isArray(data.RES_MAIN_LOAD_BERATER) && Array.isArray(data[IDs.ENT_BERATER])) {
            const fnd1 = data.RES_MAIN_LOAD_BERATER.find((b: any) => b.extern === 1 /* Externer Berater */ || b.extern === 2 /* Benutzerspezifischer Berater */);
            if (fnd1) {
                const fnd2 = data[IDs.ENT_BERATER].find((b: any) => b.tid === fnd1.tid);
                if (fnd2) {
                    formData.setValue('tid', fnd2.tid);
                    formData.setValue('name', fnd2.name);
                    formData.setValue('strasse', fnd2.strasse);
                    formData.setValue('plz', fnd2.plz);
                    formData.setValue('ort', fnd2.ort);
                    formData.setValue('mail', fnd2.mail);
                    formData.setValue('telefon', fnd2.telefon);
                    this.props.onChange(null, true);
                }
            }
        }
        this.setState({ formData });
    }

    render() {
        const { formConfig, formData } = this.state;
        if (formConfig && formData) {
            return <div id='form_externer_berater'>
                <div style={{
                    marginBottom: 5,
                    paddingBottom: 10,
                    borderBottom: '1px solid gray'
                }}></div>
                <WForm
                    entity={IDs.ENT_BERATER}
                    titel={'AddExternBerater'}
                    layout={'flowV2'}
                    config={formConfig}
                    dataIn={formData}
                    hiddenFormFields={['login', 'password', 'hwk', 'extern', 'plz_bereiche', 'bereich_key', 'password_reset_requested']}
                    // validateField={this.validateField}
                    onFormChange={this.onFormChange}
                    showFieldsHelp={true}
                    hideCancel={true}
                    hideSave={true}
                    hideTitel={true}
                    onFormSave={() => { }}
                    onFormCancel={() => { }}
                    callBeforeOnFormSave={(data: any, callback: () => void) => {
                        if (data.mail) {
                            this.apiService.call('checkMailExistence', { mail: data.mail, tid: data.tid, entity: IDs.ENT_BERATER, module: IDs.MOD_ETOOL_ADMIN },
                                (res: string, suc: boolean) => {
                                    // console.log(res, suc);
                                    if (suc) {
                                        if (res === '1') {
                                            alert('E-Mail-Adresse existiert bereits.');
                                        } else {
                                            callback();
                                        }
                                    } else {
                                        alert('Server Error');
                                    }
                                }
                            );
                        }
                    }}
                />
            </div>;
        }
        return null;
    }

    onFormChange(fData: WFormData) {
        const { data } = this.props;
        const { formData } = this.state;
        const bereich = this.apiService.getBereichKey();
        const values = fData.getAllValues();
        if (values.mail) {
            const fnd = (data[IDs.ENT_BERATER] || []).find((b: any) => b.mail === values.mail && (b.extern === 1 /* Externer Berater */ || b.extern === 2 /* Benutzerspezifischer Berater */));
            if (fnd) {
                // Berater für weitere Bereiche
                const beraterBereichKeys = (data[IDs.ENT_BERATER_BEREICHE] || []).filter((bb: any) => bb.berater_orig === fnd.tid).map((bb: any) => bb.bereich_key_orig);
                beraterBereichKeys.push(fnd.bereich_key_orig);
                // console.log(fnd, beraterBereichKeys, bereich);
                if (beraterBereichKeys.indexOf(bereich) !== -1 && fnd.tid !== values.tid) {
                    alert('Berater ' + values.mail + ' existiert schon. Daten werden übernommen.');
                    formData.setValue('tid', fnd.tid);
                    formData.setValue('name', fnd.name);
                    formData.setValue('strasse', fnd.strasse);
                    formData.setValue('plz', fnd.plz);
                    formData.setValue('ort', fnd.ort);
                    formData.setValue('telefon', fnd.telefon);
                }
            } else {
                formData.setValue('tid', null);
            }
        }
        formData.setValue('bereich_key', bereich);
        this.setState({ formData });
        this.props.onChange(formData.getAllValues(), false);
    }

    // validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
    //     switch (key) {
    //         case 'mail':
    //             if (value && value !== '') {
    //                 if (
    //                     value.toLowerCase() !== this.mails[data.values.tid || null]
    //                     && Object.values(this.mails).indexOf(value.toLowerCase()) > -1
    //                 ) {
    //                     return 'E-Mail-Adresse existiert bereits.';
    //                 }
    //             }
    //             break;
    //     }
    // }
}
